import { combineReducers } from "redux";
import headerReducer from "@gcloud-npm/next12.app-controller.reducers-sagas.header-reducer-r";
import mainReducer from "@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-r";
import modalsReducer from "@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer";
import uiReducer from "reducers/ui";

const rootReducers = () =>
  combineReducers({
    header: headerReducer,
    main: mainReducer,
    modals: modalsReducer,
    ui: uiReducer,
  });

export default rootReducers;
